<template>
  <div>
    <div class="widget_events_content_top" max-width="470 600 775">
      <ul class="tabs_level_1" v-if="showTabs">
        <li>
          <a
            v-if="defaultTid == null"
            href="#"
            :class="{ 'active-trail': tplactiveTID == null }"
            @click.prevent="changeTab()"
            >All</a
          >
          <a
            v-else
            href="#"
            :class="{ 'active-trail': tplactiveTID == null }"
            @click.prevent="changeTab(defaultTid, 0)"
            >All</a
          >
        </li>
        <li v-for="(tab, index) in tabs" :key="index">
          <a
            href="#"
            :class="{
              'active-trail':
                tab.tid == tplactiveTID || tab.tid == activeParentTid,
            }"
            @click.prevent="changeTab(tab.tid, 0)"
            >{{ tab.name }}</a
          >
        </li>
      </ul>

      <div class="widget_events_content_top_ribbon" v-if="showTabs">
        <ul v-show="subTabs && tplactiveTID">
          <li v-for="(subTab, index) in subTabs" :key="index">
            <a
              href="#"
              :class="{ 'active-sub-term': subTab.tid == tplactiveTID }"
              @click.prevent="changeTab(subTab.tid, 1, subTab.parent_tid)"
              >{{ subTab.name }}</a
            >
          </li>
        </ul>
      </div>

      <div class="widget_events_content_top_ribbon" v-if="!showTabs">
        <div class="widget_events_content_top_ribbon_title">
          <h2>
            <strong>{{ title }}</strong
            ><small>{{ subtitle }}</small>
          </h2>
        </div>
        <ul class="active-sub-nav" v-if="showSubTags">
          <li>
            <a
              :class="{ 'active-sub-term': statetid.activeTid == defaultTid }"
              @click.prevent="changeTab(defaultTid, 0)"
              >All</a
            >
          </li>
          <li v-for="(subTab, index) in tabs" :key="index">
            <a
              href="#"
              :class="{ 'active-sub-term': subTab.tid == tplactiveTID }"
              @click.prevent="changeTab(subTab.tid, 1, subTab.parent_tid)"
              >{{ subTab.name }}</a
            >
          </li>
        </ul>
      </div>

      <div class="widget_events_content_list-container">
        <ul class="view_select">
          <li>
            <a
              href="#"
              :class="{ active_view: this.view == 'day' }"
              @click.prevent="changeView('day')"
              >Day</a
            >
          </li>
          <li>
            <a
              href="#"
              :class="{ active_view: this.view == 'week' }"
              @click.prevent="changeView('week')"
              >Week</a
            >
          </li>
          <li>
            <a
              href="#"
              :class="{ active_view: this.view == 'month' }"
              @click.prevent="changeView('month')"
              >Month</a
            >
          </li>
          <li>
            <a
              href="#"
              :class="{ active_view: this.view == 'list' }"
              @click.prevent="changeView('list')"
              >List</a
            >
          </li>
        </ul>

        <div class="widget_events_content_list-views">
          <calendar-day v-if="view == 'day'"></calendar-day>
          <calendar-week v-if="view == 'week'"></calendar-week>
          <calendar-month v-if="view == 'month'"></calendar-month>
          <calendar-list v-if="view == 'list'"></calendar-list>

          <div id="widget_events_content_loader">
            <h3>loading</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*import * as tagsjson    from '../../api/events-tag.json'
import * as eventsjson  from '../../api/events-widget-content.json'*/

import store from "./CalendarStoreEvents";

import CalendarDay from "./CalendarDay";
import CalendarWeek from "./CalendarWeek";
import CalendarMonth from "./CalendarMonth";
import CalendarList from "./CalendarList";

export default {
  name: "calendar",
  components: {
    CalendarDay,
    CalendarWeek,
    CalendarMonth,
    CalendarList,
  },
  data() {
    return {
      tabs: [],
      tags: store.tagsjson,
      activeParentTid: null,
      defaultTid: null,
      subTabs: [],
      depth: 0,
      view: "day",
      state: store.state,
      statetid: store.statetid,
      groupBy: null,

      title: null,
      subtitle: null,

      showSubTags: true,
      showTabs: true,
    };
  },

  methods: {
    changeTab(tid, depth, parent_tid) {
      this.statetid.activeTid = tid;
      this.depth = depth;
      this.activeParentTid = parent_tid;
    },
    changeView(viewName) {
      this.view = viewName;

      if (viewName == "day") {
        this.groupBy = "day";
      } else {
        this.groupBy = "nid";
      }

      /* this.$nextTick(function () {
          setTimeout(function(){  this.loading = false }, 3000);

      })*/
    },
    reloadEvents() {
      if (this.groupBy == "day") {
        store.getEventsByDay();
      }
      if (this.groupBy == "nid") {
        store.getEventsByNID();
      }
    },
    loadingStart() {
      document.getElementById("widget_events_content_loader").className =
        "showloader";
    },
    loadingEnd() {
      setTimeout(function () {
        document.getElementById("widget_events_content_loader").className =
          "hideloader";
      }, 500);
    },
  },

  beforeUpdate() {
    this.loadingStart();
  },
  updated() {
    this.$nextTick(function () {
      this.loadingEnd();
      console.log("updated");
    });
  },
  beforeMount() {
    this.view = jQuery(".widget_events_content_container").attr(
      "data-default-view"
    );

    if (
      jQuery(".widget_events_content_container").attr("data-default-tag") != ""
    ) {
      this.activeParentTid = jQuery(".widget_events_content_container").attr(
        "data-default-tag"
      );
      this.defaultTid = jQuery(".widget_events_content_container").attr(
        "data-default-tag"
      );
      this.statetid.activeTid = jQuery(".widget_events_content_container").attr(
        "data-default-tag"
      );
      this.depth = 0;
    } else {
      this.activeParentTid = 0;
    }

    this.title = jQuery(".widget_events_content_container").attr("data-title");
    this.subtitle = jQuery(".widget_events_content_container").attr(
      "data-subtitle"
    );

    if (
      jQuery(".widget_events_content_container").attr("data-show-subtags") == 0
    ) {
      this.showSubTags = false;
    }

    if (
      jQuery(".widget_events_content_container").attr("data-tab-design") == 0
    ) {
      this.showTabs = false;
    }

    if (this.view == "day") {
      this.groupBy = "day";
    } else {
      this.groupBy = "nid";
    }
  },
  mounted() {
    //https://www.aup.edu/sites/default/files/json/events-widget-content-new.json
    //https://www.aup.edu/api/events-widget-content-new'

    var random = Math.random();

    this.$http
      .get(
        "/sites/default/files/json/events-widget-content-new.json?cache=" +
          random,
        {
          params: {},
          headers: {
            Authorization: "bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "cache-control": "no-cache",
          },
        }
      )
      .then(
        (response) => {
          store.eventsjson = response.body;

          if (this.groupBy == "day") {
            store.getEventsByDay();
          } else {
            store.getEventsByNID();
          }
        },
        (response) => {}
      );

    // https://www.aup.edu/sites/default/files/json/event-tags.json
    // https://www.aup.edu/api/event-tags

    this.$http.get("/sites/default/files/json/event-tags.json").then(
      (response) => {
        this.tags = response.body;

        this.tabs = this.tags.filter((tag) => {
          return tag.parent_tid == this.activeParentTid;
        });
      },
      (response) => {}
    );

    this.loadingEnd();
  },

  watch: {
    statetid: {
      handler: function (value) {
        if (this.depth == 0) {
          this.subTabs = this.tags.filter((tag) => {
            return tag.parent_tid == value.activeTid;
          });
        }
        this.reloadEvents();
      },
      deep: true,
    },
    groupBy: function (groupBy) {
      this.reloadEvents();
    },
  },
  computed: {
    hasSubTabs() {
      return true;
    },

    tplactiveTID() {
      return this.statetid.activeTid;
    },
    tplEvents() {
      return this.state.events;
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Calendar.vue?8cf35d90